import {ServerAPI} from './serverApi';
import {LocalServer, RemoteHttpServer} from './server';
import {Client, CachedClient, BasicClient} from './client';
import {InMemoryCache} from './cache';
import {MemoizedHasher} from './hash';
import {DEBUG_ATTACH_TO_GLOBAL_THIS} from './utils/constants';

// Useful for console debugging
function bindClientToGlobalThis(client: Client) {
  if (typeof globalThis !== 'undefined' && DEBUG_ATTACH_TO_GLOBAL_THIS) {
    (globalThis as any).cgquery = client.query.bind(client);
  }
}
export function createLocalClient(backend: ServerAPI): Client {
  const hashing = new MemoizedHasher();
  const cache = new InMemoryCache({keyFn: hashing.typedNodeId});
  const server = new LocalServer(cache, backend);

  const client = new BasicClient(server);

  bindClientToGlobalThis(client);
  return client;
}

export function createRemoteClient(
  weaveUrl: string,
  tokenFunc: () => Promise<string | undefined>,
  isAdmin: boolean = false
): Client {
  const remoteServer = new RemoteHttpServer({
    weaveUrl,
    useGzip: true,
    tokenFunc,
    useAdminPrivileges: isAdmin,
  });
  const client = new CachedClient(new BasicClient(remoteServer));

  bindClientToGlobalThis(client);
  return client;
}
